import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal", "search", "grid", "input", "preview"]

  open() {
    this.modalTarget.showModal()
    this.searchTarget.focus()
  }

  close() {
    this.modalTarget.close()
    this.searchTarget.value = ""
    this.filter()
  }

  filter() {
    const query = this.searchTarget.value.toLowerCase()
    const icons = this.gridTarget.querySelectorAll("[data-icon-name]")

    icons.forEach(icon => {
      const name = icon.dataset.iconName
      const visible = name.includes(query)
      icon.classList.toggle("hidden", !visible)
    })
  }

  select(event) {
    const iconName = event.currentTarget.dataset.iconName

    // Update hidden input
    this.inputTarget.value = iconName

    // Update preview
    const svg = event.currentTarget.querySelector("svg").cloneNode(true)
    this.previewTarget.innerHTML = ""
    this.previewTarget.appendChild(svg)

    // Dispatch change event for any listeners
    this.inputTarget.dispatchEvent(new Event("change", { bubbles: true }))

    this.close()
  }

  clear() {
    this.inputTarget.value = ""
    this.previewTarget.innerHTML = '<span class="text-base-content/50">?</span>'
    this.inputTarget.dispatchEvent(new Event("change", { bubbles: true }))
  }
}
